export const presets = {
  small: { height: '32px', padding: '0px 8px' },
  medium: { height: '48px', padding: '0px 12px' },
}
